<div role="dialog" aria-labelledby="softphoneCallTitle" aria-describedby="softphoneCallStatus">
  <div class="modal-content border-0">
    <div class="modal-header">
      <h5 class="modal-title mb-0" id="softphoneCallTitle">
        {{
          'softphone.callDialog.title'
            | translate
              : {
                  name:
                    softphone.activeContact?.name ||
                    softphone.activeContact?.phone
                }
        }}
      </h5>
      <button
        type="button"
        class="btn-close"
        [attr.aria-label]="'softphone.callDialog.minimize' | translate"
        (click)="minimize()"
      ></button>
    </div>

    <div class="modal-body text-center">
      <div class="avatar-lg mx-auto mb-2">
        @if (softphone.activeContact?.image) {
          <img [src]="$safeNavigationMigration(softphone.activeContact?.image)" alt="" class="img-thumbnail rounded-circle" />
        } @else {
          <span class="avatar-title bg-soft-success text-success rounded-circle">
            <i class="ri-user-3-line font-24"></i>
          </span>
        }
      </div>

      <h4 class="mb-1">{{ softphone.activeContact?.name || softphone.activeContact?.phone }}</h4>
      <p class="text-muted mb-3">{{ softphone.activeContact?.phone }}</p>

      <div id="softphoneCallStatus" aria-live="polite">
        @if ((softphone.state$ | async) === 'incall') {
          <span class="badge bg-soft-success text-success font-13 px-2 py-1">
            <i class="ri-phone-fill me-1"></i>
            {{ 'softphone.callDialog.inCall' | translate }} ·
            {{ softphone.formatDuration((softphone.duration$ | async) ?? 0) }}
          </span>
        } @else {
          <span class="badge bg-soft-warning text-warning font-13 px-2 py-1">
            <i class="ri-phone-line me-1"></i>
            {{ 'softphone.callDialog.ringing' | translate }}
          </span>
        }
      </div>
    </div>

    <div class="modal-footer justify-content-center border-0 pt-0">
      <button type="button" class="btn btn-light" (click)="minimize()">
        <i class="ri-subtract-line me-1"></i>
        {{ 'softphone.callDialog.minimize' | translate }}
      </button>
      <button type="button" class="btn btn-danger" (click)="hangup()">
        <i class="ri-phone-fill me-1"></i>
        {{ 'softphone.callDialog.hangup' | translate }}
      </button>
    </div>
  </div>
</div>
